<template>
  <div class="autocomplete w-full">
    <input @input="textChanged"
           @change="textOnChange"
           :class="classes ? classes : 'tr-input'"
           type="text" placeholder="Search for your address" v-model="localLocation"
           v-validate="'required'"
           name="Address">
    <ul class="autocomplete-items">
      <li class="prediction" v-for="(result, i) in searchResults" :key="i" @click="setValue(result)">
        {{ result.description }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    found: {
      type: Function
    },
    location: {
      type: String
    },
    classes: {
      type: String
    }
  },
  name: 'Places',
  data: () => ({
    searchResults: [],
    service: null, // will reveal this later 🕵️,
    search_break: false,
    selectedPlace: null,
    localLocation: '',
    init: true
  }),
  watch: {
    localLocation (newValue) {
      if (newValue && !this.search_break && !this.init) {
        this.service.getPlacePredictions({
          input: this.localLocation,
          fields: ['address_components', 'geometry'],
          types: ['establishment']
        }, this.displaySuggestions)
      }
      if (newValue === '') {
        this.searchResults = []
      }
    }
  },
  methods: {
    textChanged () {
      this.init = false
    },
    textOnChange () {
      if (this.localLocation === '') {
        this.init = true
        this.localLocation = this.location
      }
    },
    setValue (value) {
      this.searchResults = []
      this.search_break = true
      setTimeout(() => {
        this.search_break = false
      }, 3000)
      this.localLocation = value.structured_formatting.main_text
      this.found(value, this.localLocation)
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction)

    }
  },
  beforeCreate () {
  },
  mounted () {
    this.MapsInit()
    setTimeout(() => {
      this.localLocation = this.location
    }, 500)
  }
}
</script>

<style lang="scss">
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
  background: white;

}
.autocomplete-items li {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #c3c3c3;
}
.autocomplete-items li:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;

  input {
    margin-bottom: 0;
  }

}
</style>
